import { black1, grayFilter, grey, grey13Opacity38, grey9, yellow1 } from 'app/components/ThemeProvider/colors';
import { SxProps } from '@mui/material';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '12px 16px',
  background: 'transparent',

  [theme.breakpoints.down('md')]: {
    fontSize: '14px !important',
    p: '8px !important',
  },
};
export const inputsBox: SxProps = {
  marginTop: '41px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  borderRadius: '10px',
  gap: '28px',
  p: '30px 38px',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  minWidth: 'fit-content',
  [theme.breakpoints.down('md')]: {
    p: '20px',
  },
};
export const saveTemplateBtn: SxProps = {
  display: 'flex',
  gap: '12px',
  color: 'black',

  '& .MuiSvgIcon-root': { width: '22px', height: '22px' },

  '&.Mui-disabled': {
    backgroundColor: grey9,
    color: grey13Opacity38,
  },
};

export const pagination: SxProps = {
  '& .MuiPaginationItem-rounded, .MuiPaginationItem-previousNext': {
    borderRadius: '8px !important',
    width: '32px !important',
    height: '32px !important',
    background: 'white !important',
    borderColor: 'rgba(20, 25, 31, 0.10)',
    color: `${black1} !important`,
    fontWeight: '700 !important',
    fontFamily: 'Yelo',
  },

  '& ul li:first-of-type': {
    marginRight: '0',
  },

  '& ul li:last-of-type': {
    marginLeft: '0',
  },

  '& .Mui-disabled': {
    background: 'rgba(20, 25, 31, 0.10) !important',
  },

  '& .Mui-selected': {
    borderColor: black1,
  },
};
export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 48px',
  height: '75px',
};

export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '131px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
};
export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
};

export const selectDetailsBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  maxWidth: '656px',
  [theme.breakpoints.down(768)]: {
    flexDirection: 'column',
    gap: '16px',
  },
};

export const inputOutlined: SxProps = {
  fontSize: '16px',
  fontWeight: 400,
  height: '40px',
  paddingLeft: '16px',
  borderWidth: '1px',
  borderRadius: '8px',
  lineHeight: 1,
  backgroundColor: grayFilter,
  '& .MuiInputBase-input::placeholder': {
    fontSize: '16px',
    fontWeight: '400px',
    color: 'rgba(20, 25, 31, 0.4)',
  },

  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: grey,
    borderWidth: '0.5px',
  },
};
export const greenBtn: SxProps = {
  backgroundColor: 'rgba(36, 176, 126, 0.95)',
  color: 'white',
  '&:hover': {
    background: '#1BAC78',
  },
};

export const inputsWrapper: SxProps = {
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
};
